import Vue from 'vue'
function tracer(spm) {
  return function (target, name, descriptor) {
    let oldValue = descriptor.value;
    descriptor.value = function (...args) {
      mcTracer.click(spm)
      oldValue.bind(this, ...args)
    };
    return descriptor;
  }
}
tracer.install = function (Vue, options) {
  Vue.tracer = tracer
  window.tracer = tracer
  Object.defineProperties(Vue.prototype, {
    tracer: {
      get() {
        return tracer
      }
    }
  })
}

Vue.use(tracer)
export default tracer